// extracted by mini-css-extract-plugin
export default {"sizes":"y8Eua","size":"W3FA7","label":"nIufp","item":"WC9gs","value":"bi6b0","groups":"hTck2","group":"jjQGN","groupTitle":"hWD_G","groupValues":"tOGwT","sizeSeparator":"YVQCG"};